module.exports = __webpack_public_path__ + "img/y13.0e342cce.jpg";